module.exports = "<app-navbar></app-navbar>\n<app-centersearch></app-centersearch>\n<app-footer></app-footer>"